import {Injectable} from '@angular/core'
import { Response } from '@angular/http/src/static_response';
import { Http, RequestOptions,Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { ConfigurationReaderBase } from './ConfigurationReader';
import { AuthenticationBase } from './Authentication';
import { ReturnStatement } from '@angular/compiler/src/output/output_ast';
import { HttpUtility } from './HttpUtility';
import { Report } from '../model/Report';

export abstract class MainNavigationBase{
    constructor(protected http: Http, protected configurationReader: ConfigurationReaderBase, protected authentication:AuthenticationBase){}
    abstract GetReports():Observable<Array<Report>>;
}

@Injectable()
export class MainNavigationService extends MainNavigationBase {
    constructor(protected http: Http, protected configurationReader: ConfigurationReaderBase,protected authentication:AuthenticationBase,
                protected httpUtility: HttpUtility){
        super(http,configurationReader, authentication);
    }
    
    GetReports():Observable<Array<Report>> {       
        
        return this.http.get(this.configurationReader.Configuration.apiBaseUrl + 'common/list', this.authentication.getAuthenticationHeader())
                .map((resp)=><Array<Report>>resp.json())
                .catch(this.httpUtility.handleError);
    }
    
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Shared/service/MainNavigation.service.ts